var _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProducts({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 350,
    viewBox: "0 0 400 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_113_53",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.5 22L332 98.5V251.5L199.5 328L67 251.5V98.5L133.25 60.25L199.5 22Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M199.5 175H189.5V328H199.5H209.5V175H199.5ZM67 98.5L61.9999 107.16L194.5 183.66L199.5 175L204.5 166.34L72.0001 89.8398L67 98.5ZM332 98.5L327 89.8398L260.75 128.09L265.75 136.75L270.75 145.41L337 107.16L332 98.5ZM265.75 136.75L260.75 128.09L194.5 166.34L199.5 175L204.5 183.66L270.75 145.41L265.75 136.75ZM133.25 60.25L128.25 68.9102L260.75 145.41L265.75 136.75L270.75 128.09L138.25 51.5898L133.25 60.25ZM199.5 22L209.5 4.67955L199.5 -1.09409L189.5 4.67955L199.5 22ZM332 98.5H352V86.9531L342 81.1796L332 98.5ZM332 251.5L342 268.82L352 263.047V251.5H332ZM199.5 328L189.5 345.32L199.5 351.094L209.5 345.32L199.5 328ZM67 251.5H47V263.047L56.9999 268.82L67 251.5ZM67 98.5L56.9999 81.1796L47 86.9531V98.5H67ZM199.5 22L189.5 39.3204L322 115.82L332 98.5L342 81.1796L209.5 4.67955L199.5 22ZM332 98.5H312V251.5H332H352V98.5H332ZM332 251.5L322 234.18L189.5 310.68L199.5 328L209.5 345.32L342 268.82L332 251.5ZM199.5 328L209.5 310.68L77.0001 234.18L67 251.5L56.9999 268.82L189.5 345.32L199.5 328ZM67 251.5H87V98.5H67H47V251.5H67ZM67 98.5L77.0001 115.82L143.25 77.5704L133.25 60.25L123.25 42.9296L56.9999 81.1796L67 98.5ZM133.25 60.25L143.25 77.5704L209.5 39.3204L199.5 22L189.5 4.67955L123.25 42.9296L133.25 60.25Z",
    fill: "#EA3377",
    mask: "url(#path-1-inside-1_113_53)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.1b6a412b7388334b6b1900abceaa52fb.svg";
export { ForwardRef as ReactComponent };